import Field from "./Field";

/**
 * A field that pretends to be a different field.
 *
 * Used to render a field from step A in step B, or when a field is
 * not available during initialization.
 *
 * @abstract
 */
export default class CrossReferencedField extends Field {

    constructor(name, step, modelPath) {
        super(name, step);
        this.modelPath = modelPath;
    }

    onChange = nextValue => {
        let targetField = this.getCrossReferencedField()
        if (targetField) {
            targetField.setValue(nextValue)
        }

        return false
    }


    getModelPath() {
        return [this.modelPath, this.name].join(Field.PathSeparator)
    }

    // TODO: Instead of overriding all getters, just override getProperty or getPath methods.

    // Override common getters to reference the field.
    get value() {
        return this.getCrossReferencedField().getProperty('value')
    }

    get unit() {
        return this.getCrossReferencedField().getProperty('unit')
    }

    get disabled() {
        return this.getCrossReferencedField().getProperty('disabled')
    }

    get visible() {
        if (this.canCrossReferencedFieldBeAccessed()) {

            // This may raise an error because visibility is checked before a step is unmounted
            // but after it's been removed from the store.
            try {
                return this.getCrossReferencedField().getProperty('visible')
            } catch (e) {
                return false
            }

        }

        // Field won't even attempt to render if it's not visible, so we can
        // safely use this method to make sure we don't get any NPEs from other getters.
        return false
    }

    get items() {
        return this.getCrossReferencedField().getProperty('items')
    }

    get label() {
        return this.getCrossReferencedField().getProperty('label')
    }

    get text() {
        return this.getCrossReferencedField().getProperty('text')
    }

    get warning() {
        return this.getCrossReferencedField().getProperty('warning')
    }

    get type() {
        return this.getCrossReferencedField().getProperty('type')
    }

    /**
     * Checks whether the cross-referenced field can be accessed already.
     *
     * @abstract
     * @protected
     * @return {Boolean}
     */
    canCrossReferencedFieldBeAccessed() {
        return Boolean(this.getConfigurator().getStepsManager().getStepByName(this.modelPath));
    }

    /**
     * Returns the actual cross-referenced field.
     * Must *not* return null.
     *
     * @abstract
     * @protected
     * @return {Field}
     */
    getCrossReferencedField() {
        let other = this.getConfigurator().getStepsManager().getStepByName(this.modelPath);
        return other.getField(this.name);
    }
}
